import React from 'react';
import styled from 'styled-components';
import { WidgetWrapper } from '../style/ThemeProvider/widgetWrapper';
import { WidgetHeader } from '../WidgetHeader';
import { Loader, TextDelayedLoader } from '../Loader';
const MainWrap = styled.div.withConfig({
  displayName: "WidgetFallback__MainWrap",
  componentId: "sc-1gpzjod-0"
})([""]);

var _ref = /*#__PURE__*/React.createElement(Loader, null);

// Note: the fallback may be or a Loader when measures embedded in an app or
// the widget placeholder when in dashboard
export const WidgetFallback = /*#__PURE__*/React.memo(({
  noWidgetHeader,
  appTitle,
  smallWidget,
  embedded,
  name
}) => embedded && !noWidgetHeader ? /*#__PURE__*/React.createElement(MainWrap, {
  id: "widget-fallback"
}, /*#__PURE__*/React.createElement(WidgetHeader, {
  appTitle: appTitle === null || appTitle === void 0 ? void 0 : appTitle.toLocaleUpperCase(),
  smallWidget: true,
  noIcon: true
}), /*#__PURE__*/React.createElement(WidgetWrapper, {
  id: "widget-fallback-body",
  smallWidget: smallWidget
}, /*#__PURE__*/React.createElement(TextDelayedLoader, {
  smallWidget: smallWidget,
  name: name
}))) : _ref);
export default WidgetFallback;